<template lang="html">
  <div class="logo-wrap bg-white p-3 pb-1">
    <img src="@/assets/logos_header.svg" alt="Diensten Centrum" class="w-100" />
  </div>
  <div>
    <h1 class="title text-white fw-bold">Wie speelt er?</h1>
    <input
      v-model="firstName"
      class="form-control bg-outline-primary text-dark field no-focusborder fw-bold"
      type="text"
      ref="inputfield"
      placeholder="Voornaam"
      required
    />
    <input
      v-model="lastName"
      class="form-control bg-outline-primary text-dark field no-focusborder fw-bold"
      type="text"
      ref="inputfield"
      placeholder="Achternaam"
      required
    />
    <!-- <input
    v-model="company"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Bedrijfsnaam"
    required
  />
  <input
    v-model="email"
    class="form-control field no-focusborder"
    type="email"
    ref="inputfield"
    placeholder="E-mailadres"
    required
  />
  {{ validateEmail }} -->
    <div class="d-grid gap-2">
      <button
        type="button"
        class="btn btn-secondary text-info btn-lg fw-bold"
        :disabled="isDisabled == true"
        @click="setPersonalData()"
      >
        Doorgaan
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    company: null,
    email: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName && this.lastName) {
        return false;
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      // this.$store.commit("setCompany", this.company);
      // this.$store.commit("setEmail", this.email);
      // this.$store.commit("setEmail", this.email);
    },
  },
};
</script>

<style lang="css" scoped>
.logo-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: rgba(40, 110, 187, 0.9);
  z-index: 10;
}

.logo-wrap img {
  display: block;
}

h1 {
  font-size: 30px;
  margin-top: 110px;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  width: 100%;
  padding: 10px;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 20px;
}
.field::placeholder {
  opacity: 0.5;
}
</style>
